import { agencyDetailed } from '@app/models';
import {gql} from 'apollo-angular';

export const updateAgencyDisplaySettings = 'updateAgencyDisplaySettings';
export const updateAgencyDisplaySettingsMutation = gql`
  mutation updateAgencyDisplaySettings($agency: AgencyInput!) {
    updateAgencyDisplaySettings(agency: $agency) {
      ...agencyDetailed
    }
  }
  ${agencyDetailed}
`;
